// extracted by mini-css-extract-plugin
export default {"root":"ReferencesItem_root__PGWoQ","rootNoPerformer":"ReferencesItem_rootNoPerformer__69+3h","actions":"ReferencesItem_actions__aDcJ7"};